import styled, { css } from 'styled-components';
import breakpoint from '../mixins/breakpoint';

/**
 * @param {BreakpointsToBooleans} props
 */
const ShowFor = styled.div`
    ${(p) =>
        !p.xxsmall &&
        css`
            ${breakpoint('xxsmall', { only: true })} {
                display: none;
            }
        `}
    ${(p) =>
        !p.xsmall &&
        css`
            ${breakpoint('xsmall', { only: true })} {
                display: none;
            }
        `}
    ${(p) =>
        !p.small &&
        css`
            ${breakpoint('small', { only: true })} {
                display: none;
            }
        `}
    ${(p) =>
        !p.medium &&
        css`
            ${breakpoint('medium', { only: true })} {
                display: none;
            }
        `}
    ${(p) =>
        !p.large &&
        css`
            ${breakpoint('large', { only: true })} {
                display: none;
            }
        `}
    ${(p) =>
        !p.xlarge &&
        css`
            ${breakpoint('xlarge', { only: true })} {
                display: none;
            }
        `}
    ${(p) =>
        !p.xxlarge &&
        css`
            ${breakpoint('xxlarge', { only: true })} {
                display: none;
            }
        `}
`;

export default ShowFor;
